import React from 'react';
type PageHeroProps = {
  title: string;
  subtitle?: string;
  image: string;
  children?: React.ReactNode;
};
export function PageHero({
  title,
  subtitle,
  image,
  children
}: PageHeroProps) {
  return <section className="relative isolate overflow-hidden" data-id="element-171" data-mp="3tallm5m3hbpg">
      <img src={image} alt="" className="absolute inset-0 -z-10 h-full w-full object-cover" data-id="element-172" data-mp="3tc6g5v8esunb" />
      <div className="absolute inset-0 -z-10 bg-ink/75" data-id="element-173" data-mp="25c28wslvvot" />
      <div className="mx-auto max-w-6xl px-6 pb-20 pt-36 text-center xl:pb-24 xl:pt-48" data-id="element-174" data-mp="puegrvry18f3">
        {subtitle && <p className="font-script text-xl italic text-white/90 md:text-2xl" data-id="element-175" data-mp="uqv5os6yvqt8">{subtitle}</p>}
        <h1 className="mt-3 font-slab text-4xl font-bold uppercase tracking-[0.12em] md:text-6xl" data-id="element-176" data-mp="g28sox4tbb56">{title}</h1>
        {children}
      </div>
    </section>;
}